import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import BaseSelector from '@/components/selectors/BaseSelector';

interface HealthState {
    id: string;
    value: string;
    icon: string;
    color: string;
}

interface AllHealthsSelectorProps {
    healthStates: Record<string, HealthState>;
    selectedOnStart?: string[];
    allHealthsSelectedOnStart?: boolean;
    onSelectedHealthsChanged: (selectedHealths: string[]) => void;
}

const AllHealthsSelector: React.FC<AllHealthsSelectorProps> = ({
    healthStates,
    selectedOnStart = [],
    allHealthsSelectedOnStart = false,
    onSelectedHealthsChanged
}) => {
    const { t } = useTranslation();

    const [selectedHealths, setSelectedHealths] = useState<string[]>([]);
    const [initialized, setInitialized] = useState(false);

    const healthStateValues = Object.values(healthStates);

    useEffect(() => {
        if (!initialized) {
            if (allHealthsSelectedOnStart) {
                setSelectedHealths(healthStateValues.map((x) => x.id));
            } else {
                setSelectedHealths([...selectedOnStart]);
            }
            setInitialized(true);
        }
    }, [allHealthsSelectedOnStart, selectedOnStart, initialized]);

    useEffect(() => {
        if (initialized) {
            onSelectedHealthsChanged([...selectedHealths]);
        }
    }, [selectedHealths, initialized, onSelectedHealthsChanged]);

    const items = healthStateValues.map((h) => ({ value: h.id, text: t(h.value) }));

    return (
        <BaseSelector
            multiple
            selectAll
            value={selectedHealths}
            items={items}
            itemText="text"
            itemValue="value"
            label={t('status')}
            onChange={(val) => setSelectedHealths(val)}
            selectDisplayLabels={{
                allLabel: t('allHealth'),
                placeholderLabel: t('selectStatus')
            }}
        />
    );
};

export default AllHealthsSelector;
